var map = {
	"./calcular-imposto.svg": "836d",
	"./camera-de-seguranca.svg": "a317",
	"./licenca.svg": "04b4",
	"./moedas-do-dolar.svg": "8e10",
	"./prescricao.svg": "1443",
	"./velocimetro.svg": "8842"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "603e6";